import { recipientsAreSame, SourceData, Suggestion, Value } from 'components/ShareSheet/RecipientSelector/Types'
import { RecipientsSelectorValueType, Workspace } from 'types'

import { State, Action, GroupInfo } from './Types'

export const filterUsersByNameOrEmail = (users: SourceData['users'], match: string) => {
  return users.filter(({ first_name, last_name, email }) => {
    const nameString = `${first_name}${last_name}`.toLowerCase()
    return nameString.includes(match) || email.toLowerCase().includes(match)
  })
}

export const filterGroupsByName = (groups: SourceData['accessMemberGroups'], match: string) => {
  return groups?.filter(({ name }) => name.toLowerCase().includes(match)) || []
}

export const buildGroupValue = (
  type: RecipientsSelectorValueType,
  group: GroupInfo,
  currentWorkspace: Workspace | undefined,
) => {
  const modifiedGroup =
    type === RecipientsSelectorValueType.LayerEditors
      ? { type: RecipientsSelectorValueType.LayerEditors, value: group }
      : { type: RecipientsSelectorValueType.Company, value: currentWorkspace }

  return modifiedGroup as Value
}

export const filterChannelsByName = (channels: SourceData['channels'], match: string) => {
  return channels.filter(({ name }) => name.toLowerCase().includes(match))
}

export const filterSelectedMatches = (matches: Suggestion[], selectedValues: Value[]): Suggestion[] => {
  return matches.filter(
    (match) =>
      !selectedValues.some((v) => {
        return recipientsAreSame(match, v)
      }),
  )
}

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'updateHighlightedSuggestionIndex': {
      const { index } = action
      return { ...state, highlightedSuggestionIndex: index }
    }
    case 'updateHighlightedRecipientIndex': {
      const { index } = action
      return { ...state, highlightedRecipientIndex: index }
    }
    case 'updateQuery':
      const { query } = action
      const { sourceData } = state

      const transformedQuery = query.replace(' ', '').toLowerCase()

      return {
        ...state,
        query: action.query,
        matches: [
          ...filterGroupsByName(sourceData.accessMemberGroups, transformedQuery)?.map((group) => ({
            type: RecipientsSelectorValueType.AccessMemberGroup,
            value: group,
          })),
          ...filterChannelsByName(sourceData.channels, transformedQuery).map((channel) => ({
            type: RecipientsSelectorValueType.Channel,
            value: channel,
          })),
          ...filterUsersByNameOrEmail(sourceData.users, transformedQuery).map((user) => ({
            type: RecipientsSelectorValueType.User,
            value: user,
          })),
        ] as Suggestion[],
        highlightedSuggestionIndex: -1,
      }
    case 'updateSourceData':
      const { users, channels, accessMemberGroups = [] } = action.sourceData
      return {
        ...state,
        matches: [
          ...accessMemberGroups.map((group) => ({
            type: RecipientsSelectorValueType.AccessMemberGroup,
            value: group,
          })),
          ...channels.map((channel) => ({
            type: RecipientsSelectorValueType.Channel,
            value: channel,
          })),
          ...users.map((user) => ({
            type: RecipientsSelectorValueType.User,
            value: user,
          })),
        ] as Suggestion[],
        sourceData: action.sourceData,
      }
    default:
      return { ...state }
  }
}
